export function capitalize(text: string, sep: string) {
	return text
		.split(sep)
		.map((t) =>
			t.length > 0 ? t.charAt(0).toUpperCase() + (t.length > 1 ? t.substring(1) : '') : ''
		)
		.join(' ');
}

export function assignWithDetail<T>(validValues: T[], defaultValue: T, value?: T | null): T {
	if (value && validValues.includes(value)) {
		return value;
	}
	return defaultValue;
}
